import { render, staticRenderFns } from "./mygoods.vue?vue&type=template&id=77c279c3&"
import script from "./mygoods.vue?vue&type=script&lang=js&"
export * from "./mygoods.vue?vue&type=script&lang=js&"
import style0 from "./mygoods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports